import { number, string } from 'prop-types'
import styles from './Divider.scss';


Divider.propTypes = {
    value: number,
    label: string
}

function Divider({ label = '[label]', value = 0 }) {
    var num = null;
    if (value != 0) {
        num = (<span className={styles.num}>{value}</span>)
    }
    return (
        <div>
            <hr className="divider gap-bottom-25" />
            <div className={[styles.divider, 'gap-top-45', 'gap-bottom-45'].join(' ')}>
                {num}
                <span>{label}</span>
            </div>
        </div>

    )
}

export default Divider


// WEBPACK FOOTER //
// ./app/components/Divider.js